/*
  GLOBAL VARS
  The application has global values that can be altered from any location within the system.
  This option is recommended when we want to avoid using local storage variables and need the data to load 
  on the same page without refreshing. 
  Note: It won't work after the page is refreshed.
*/

export const GLOBAL_VARS = {
  CART:{
    lastProductSelected:'',
    lineProducts:null,
    userHlmWithCoupon:false
  },
  QUERY_SHOP_INSTANCE:{
    queryShop:null
  }
}